import {Injectable} from "@angular/core";
import {Resolve, ActivatedRouteSnapshot} from "@angular/router";
import {Api} from "./api.service";
import {Observable} from "rxjs/Observable";
import {Language} from "./api/languages/api.models";
import {Observer} from "rxjs/Observer";
import {AuthenticationService} from "./authentication.service";

@Injectable()
class LanguagesResolver implements Resolve<any> {
    constructor(private api: Api) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Language[]> {
        return Observable.create((observer: Observer<any>) => {
            let subscription = this.api.languages().collection().subscribe(
                (languages: Language[]) => {
                    observer.next(languages);
                    observer.complete();
                    subscription.unsubscribe();
                },
                (error: any) => {
                    observer.error({message: error, ngNavigationCancelingError: true});
                    subscription.unsubscribe();
                }
            );
        });
    }
}

@Injectable()
class LanguagesGroupedResolver implements Resolve<any> {
    constructor(private api: Api, private auth: AuthenticationService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<GroupedLanguages[]> {
        let filterLanguages: boolean = !!route.data['allLanguages'];

        return Observable.create((mainObservable: Observer<any>) => {
            this.auth.isAuthenticated().subscribe(
                (result: boolean) => {
                    if (result === false) {
                        return;
                    }

                    let subscription = this.api.languages().collection().subscribe(
                        (languages: Language[]) => {
                            let groupedLanguages: any[]   = [];
                            let groupedLanguagesHash: any = {};
                            let groupedLanguageLabel: any = {};

                            languages.forEach((language: Language) => {
                                if (language.territory === null) {
                                    groupedLanguageLabel[language.language] = language.label;
                                    let matches = language.label.match(/([^\s]+).*/);
                                    if (matches !== null) {
                                        groupedLanguageLabel[language.language] = matches[1];
                                    }
                                }

                                if (filterLanguages === false && this.auth.getMe().preferences.languages.indexOf(language.id) === -1) {
                                    return;
                                }

                                if (groupedLanguagesHash[language.language] === undefined) {
                                    groupedLanguages.push({
                                        languages : [],
                                        label     : groupedLanguageLabel[language.language] || language.language
                                    });

                                    groupedLanguagesHash[language.language] = groupedLanguages[groupedLanguages.length - 1];
                                } else if (groupedLanguagesHash[language.language].label === language.language) {
                                    groupedLanguagesHash[language.language].label = groupedLanguageLabel[language.language] || language.language;
                                }

                                groupedLanguagesHash[language.language].languages.push(language);
                            });

                            groupedLanguages.forEach((groupedLanguage: GroupedLanguages) => {
                                groupedLanguage.languages.sort((a: any, b:any) => {
                                    if (a.label > b.label) {
                                        return 1;
                                    } else if (a.label < b.label) {
                                        return -1;
                                    }

                                    return 0;
                                });
                            });

                            groupedLanguages.sort((a: any, b:any) => {
                                if (a.label > b.label) {
                                    return 1;
                                } else if (a.label < b.label) {
                                    return -1;
                                }

                                return 0;
                            });

                            mainObservable.next(groupedLanguages);
                            mainObservable.complete();

                            subscription.unsubscribe();
                        },
                        (error: any) => {
                            mainObservable.error({message: error, ngNavigationCancelingError: true});
                            subscription.unsubscribe();
                        }
                    );
                }
            )
        });
    }
}

class GroupedLanguages {
    label: string;
    languages: Language[];
}

export {
    LanguagesResolver,
    LanguagesGroupedResolver,
    GroupedLanguages
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/languages.resolver.ts